import { call, put, select } from 'redux-saga/effects'
import { callApi } from '@/shared/tools/apiSagaHelper'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { showSnackbar, SNACKBAR_TYPES } from '@/shared/tools/notifications/notification'
import {
  updateClubSelectra,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import { selectPageConfigurationData } from '@/store/PageConfiguration/PageConfigurationSelectors'

export const clubSelectraModuleActions = {
  CREATE_CLUB_SELECTRA: 'CREATE_CLUB_SELECTRA'
}

export function* createClubSelectra(action) {
  try {
    yield put(updateClubSelectra({loading: true, success: false, error: null, message: null}));
    const { enqueue, payload, version } = action
    const { country } = yield select(selectAuthData)
    const { interaction_club_selectra_url: interactionClubSelectraUrl } =
      yield select(selectPageConfigurationData)

    if (!interactionClubSelectraUrl){
      yield put(updateClubSelectra({loading: false, success: false, error: 'Missing URL'}))
      return
    }
    const body = {
      contact_zoho_id: payload.zohoContactId,
      contact_first_name: payload.contactFirstName,
      contact_last_name: payload.contactLastName,
      country,
      contact_email: payload.contactEmail,
      client_id: payload.clientId,
      version,
      energy_type: payload.energyType,
      offer_name: payload.offerName,
    }

    if (payload.provider_external_id_elec) {
      body.provider_external_id_elec = payload.provider_external_id_elec;
    }
    if (payload.provider_external_id_gas) {
      body.provider_external_id_gas = payload.provider_external_id_gas;
    }

    const result = yield call(callApi, {
      endpoint: interactionClubSelectraUrl,
      method: 'POST',
      showErrorSnackbar: true,
      payload: body,
    })

    yield put(updateClubSelectra({
      loading: false,
      success: true,
      message: result?.message || null,
      error: null,
    }));

    yield call(showSnackbar, enqueue, {
      type: SNACKBAR_TYPES.SUCCESS,
      message: result?.message || 'Club Selectra sent successfully',
    });

  } catch (error) {
    const data = error?.responseData
    const backendMessage =
      (typeof data?.error === 'string' && data.error.trim()) ? data.error :
        (typeof data?.message === 'string' && data.message.trim()) ? data.message :
          error?.message || 'Club Selectra sent error'

    yield put(updateClubSelectra({
      loading: false,
      success: false,
      error: backendMessage,
      message: null,
    }));

    yield call(showSnackbar, action.enqueue, {
      type: SNACKBAR_TYPES.ERROR,
      message: backendMessage,
    });

    console.error('create club selectra', error);
  }
}
